<script setup lang="ts">
import { RouterView } from 'vue-router'
import ItemAddedAlert from '@/components/alerts/ItemAddedAlert.vue'
import ItemRemovedAlert from '@/components/alerts/ItemRemovedAlert.vue'
import ErrorMessageAlert from '@/components/alerts/ErrorMessageAlert.vue'
import SuccessMessageAlert from '@/components/alerts/SuccessMessageAlert.vue'
import SnowAnimation from '@/components/SnowAnimation.vue'
import AppUpgradeOverlay from '@/components/mobile/AppUpgradeOverlay.vue'

const IS_MOBILE_APP = import.meta.env.VITE_MOBILE_APP
</script>
<template>
  <router-view />
  <AppUpgradeOverlay v-if="IS_MOBILE_APP" />
  <ItemAddedAlert></ItemAddedAlert>
  <ItemRemovedAlert></ItemRemovedAlert>
  <ErrorMessageAlert></ErrorMessageAlert>
  <SuccessMessageAlert></SuccessMessageAlert>
  <SnowAnimation />
</template>
